/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { Schedule } from './Schedule';
import {
    ScheduleFromJSON,
    ScheduleFromJSONTyped,
    ScheduleToJSON,
    ScheduleToJSONTyped,
} from './Schedule';

/**
 * 
 * @export
 * @interface ListSchedulesResponse
 */
export interface ListSchedulesResponse {
    /**
     * 
     * @type {Array<Schedule>}
     * @memberof ListSchedulesResponse
     */
    data: Array<Schedule>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListSchedulesResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListSchedulesResponse interface.
 */
export function instanceOfListSchedulesResponse(value: object): value is ListSchedulesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListSchedulesResponseFromJSON(json: any): ListSchedulesResponse {
    return ListSchedulesResponseFromJSONTyped(json, false);
}

export function ListSchedulesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListSchedulesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ScheduleFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListSchedulesResponseToJSON(json: any): ListSchedulesResponse {
      return ListSchedulesResponseToJSONTyped(json, false);
  }

  export function ListSchedulesResponseToJSONTyped(value?: ListSchedulesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ScheduleToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

